// extracted by mini-css-extract-plugin
export default {"outOfStock":"Wxy7L","icon":"gTKE_","text":"x0_aK"};